import { ACTIONS } from "app/store/actions"
import {
  ICampaign,
  ICampaignDuplicatePopup,
  ICampaignList,
  ICampaignRefreshListParams,
  IDspDealByCampaignId,
  IForecastResultByCampaignId
} from "campaign/model"
import { Action } from "redux"
import { IReportsCampaignResult } from "reports/model"

export interface ICampaignActionSetListReports extends Action {
  reports: IReportsCampaignResult[]
}

export interface ICampaignActionSetListEstimates extends Action {
  isForecast: boolean
  isDspDeal: boolean
  estimates: IForecastResultByCampaignId
}

export interface ICampaignActionSetListDspDeal extends Action {
  dspDealByCampaignId: IDspDealByCampaignId
}

export interface ICampaignActionStopRefreshing extends Action {
  params: ICampaignRefreshListParams
  filteredEntities: ICampaign[]
  rowCount?: number
}

export interface ICampaignActionSetList extends Action {
  isForecast: boolean
  isDspDeal: boolean
  list: Partial<ICampaignList>
}

export interface ICampaignActionDuplicatePopup extends Action {
  duplicatePopup: Partial<ICampaignDuplicatePopup>
}

export const campaignActionCreator = {
  setListCampaignsReports(reports: IReportsCampaignResult[]): ICampaignActionSetListReports {
    return {
      type: ACTIONS.CAMPAIGN_SET_LIST_REPORTS,
      reports
    }
  },
  setListCampaignsEstimates(
    isForecast: boolean,
    isDspDeal: boolean,
    estimates: IForecastResultByCampaignId
  ): ICampaignActionSetListEstimates {
    return {
      type: ACTIONS.CAMPAIGN_SET_LIST_ESTIMATES,
      isForecast,
      isDspDeal,
      estimates
    }
  },
  setListCampaignsDspDeal(dspDealByCampaignId: IDspDealByCampaignId): ICampaignActionSetListDspDeal {
    return {
      type: ACTIONS.CAMPAIGN_SET_LIST_DSP_DEALS,
      dspDealByCampaignId
    }
  },
  setList(isForecast: boolean, isDspDeal: boolean, list: Partial<ICampaignList>): ICampaignActionSetList {
    return {
      type: ACTIONS.CAMPAIGN_SET_LIST,
      isForecast,
      isDspDeal,
      list
    }
  },
  setCampaignDuplicate(duplicatePopup: Partial<ICampaignDuplicatePopup>): ICampaignActionDuplicatePopup {
    return {
      type: ACTIONS.CAMPAIGN_DUPLICATE_POPUP,
      duplicatePopup
    }
  }
}
